function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.5 11.5l-.354-.354A.5.5 0 000 11.5h.5zm0 2H0a.5.5 0 00.5.5v-.5zm2 0v.5a.5.5 0 00.354-.146L2.5 13.5zm11-11l.354.354a.5.5 0 000-.708L13.5 2.5zm-2-2l.354-.354a.5.5 0 00-.708 0L11.5.5zm-1.48 2.198a.5.5 0 00-.708.707l.708-.707zm.565 1.98a.5.5 0 10.707-.708l-.707.707zM0 11.5v2h1v-2H0zM.5 14h2v-1h-2v1zm2.354-.146l11-11-.708-.708-11 11 .708.708zm11-11.708l-2-2-.708.708 2 2 .708-.708zm-2.708-2l-11 11 .708.708 11-11-.708-.708zm-1.834 3.26l1.273 1.271.707-.707-1.272-1.272-.708.707z",
  fill: "#0085FF"
});
function SvgEditBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
}
export default SvgEditBlue;